
import { EventEmitter } from "events"

const ee = new EventEmitter()

ee.on("save_click", () => {
  ee.emit("save_click:action")
  ee.emit("save_click:tracking")
})

ee.on("save_success", () => {
  ee.emit("save_click:success")
})

ee.on("save_idle", () => {
  ee.emit("save_click:idle")
})


export default ee
